import { Component, Input, OnInit } from '@angular/core';
import { LAYOUT_URL } from '../../../../../shared/utils/constants';
import { ErrorModelData } from '../../../../../vass-core/interfaces/error-model-data.interface';

@Component({
  selector: 'app-error-detail',
  templateUrl: './error-detail.component.html',
  styleUrls: ['./error-detail.component.scss'],
  standalone: false,
})
export class ErrorDetailComponent implements OnInit {
  @Input() error: ErrorModelData;
  @Input() isComponent: boolean;

  public LAYOUT_NAME = LAYOUT_URL;

  constructor() {}

  ngOnInit() {}
}
